module.exports = __webpack_public_path__ + "static/media/IMG_4403.fa39952c.jpg";